var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 64,
    viewBox: "0 0 71 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6569 38.7725C39.3293 38.7725 42.3063 35.7404 42.3063 32C42.3063 28.2597 39.3293 25.2275 35.6569 25.2275C31.9846 25.2275 29.0076 28.2597 29.0076 32C29.0076 35.7404 31.9846 38.7725 35.6569 38.7725Z",
    fill: "#087EA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6569 47.238C54.0186 47.238 68.9037 40.4157 68.9037 31.9999C68.9037 23.5842 54.0186 16.7618 35.6569 16.7618C17.2952 16.7618 2.41016 23.5842 2.41016 31.9999C2.41016 40.4157 17.2952 47.238 35.6569 47.238Z",
    stroke: "#087EA4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 39.619C31.8812 55.8152 45.1246 65.5336 52.2803 61.3257C59.4361 57.1178 57.7944 40.5771 48.6136 24.3809C39.4328 8.18475 26.1893 -1.53366 19.0336 2.67422C11.8778 6.88211 13.5195 23.4228 22.7003 39.619Z",
    stroke: "#087EA4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7002 24.3808C13.5193 40.577 11.8777 57.1177 19.0334 61.3256C26.1892 65.5335 39.4326 55.8151 48.6134 39.6189C57.7943 23.4228 59.4359 6.88205 52.2802 2.67416C45.1244 -1.53372 31.881 8.18469 22.7002 24.3808Z",
    stroke: "#087EA4",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.8182,
    height: 64,
    fill: "white",
    transform: "translate(0.747803)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReact);
export default __webpack_public_path__ + "static/media/icon-react.787d88f2947e9fc64e7726eebe0c6f17.svg";
export { ForwardRef as ReactComponent };